import { PayloadAction } from '@reduxjs/toolkit';

import { FileFormat } from '@/shared/constants/file-format.constant';
import { createSlice } from '@/shared/lib/helpers/create-store-logic';

import { HistoricalDataSchema, LastDownloadedFile } from '../types/historical-data.schema';

export const initialState: HistoricalDataSchema = {
	dataVariables: [],
	alarmsVariables: [],
	statusesVariables: [],
	isAllDataVariables: false,
	isAllAlarmsVariables: false,
	isAllStatusesVariables: false,
	fileFormat: FileFormat.Csv,
};

export const historicalDataSlice = createSlice({
	name: 'historical-data',
	initialState,
	reducers: {
		setTo: (state, action: PayloadAction<Date | undefined>) => {
			state.to = action.payload;
		},
		setFrom: (state, action: PayloadAction<Date | undefined>) => {
			state.from = action.payload;
		},
		setDataVariables: (state, action: PayloadAction<string[]>) => {
			state.dataVariables = action.payload;
		},
		setAlarmsVariables: (state, action: PayloadAction<string[]>) => {
			state.alarmsVariables = action.payload;
		},
		setStatusesVariables: (state, action: PayloadAction<string[]>) => {
			state.statusesVariables = action.payload;
		},
		setIsAllDataVariables: (state, action: PayloadAction<boolean>) => {
			state.isAllDataVariables = action.payload;
		},
		setIsAllAlarmsVariables: (state, action: PayloadAction<boolean>) => {
			state.isAllAlarmsVariables = action.payload;
		},
		setIsAllStatusesVariables: (state, action: PayloadAction<boolean>) => {
			state.isAllStatusesVariables = action.payload;
		},
		setLastDownloadedFile: (state, action: PayloadAction<LastDownloadedFile>) => {
			state.lastDownloadedFile = action.payload;
		},
		setFormat: (state, action: PayloadAction<FileFormat>) => {
			state.fileFormat = action.payload;
		},
		resetFormat: (state) => {
			state.fileFormat = FileFormat.Csv;
		},
		resetData: (state) => {
			state.dataVariables = [];
			state.alarmsVariables = [];
			state.statusesVariables = [];
			state.isAllDataVariables = false;
			state.isAllAlarmsVariables = false;
			state.isAllStatusesVariables = false;
		},
	},
});

export const {
	actions: historicalDataActions,
	reducer: historicalDataReducer,
	useActions: useHistoricalDataActions,
} = historicalDataSlice;
